import { useState, useEffect } from "react";
import { selectUsers } from 'src/modules/users/selector';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectItems, selectGetStatus } from "src/modules/spItems/selectors";
import { getItems } from "src/modules/spItems/actions";
import { Comment } from "src/components/ui-icons/card";
import HistoryStatuses from "../historyStatuses/historyStatusesMobile";
import { getHistoryTimelineColorMobile } from "../historyStatuses/statusTimelineMobile";
import HistoryFieldChanges from "../historyFieldChanges";
import { ArrowDown } from "src/components/ui-icons/card";
import { TooltipItem } from "src/utils/Tooltip";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { historyChangeFieldsDocumentListName } from "src/api/config";
import moment from "moment";
import Loading from "src/components/Loading";

const HistoryCard = ({ versionView, documentCardID }: any) => {

    const historyCard: any = useAppSelector(state => selectItems(state, historyChangeFieldsDocumentListName));
    const users: any = useAppSelector(selectUsers);
    const statusGetHistory = useAppSelector((state) =>
        selectGetStatus(state, historyChangeFieldsDocumentListName)
    );
    const dispatch = useAppDispatch();
    const [approvers, setApprovers] = useState<any>({});

    const getUserEmail = (value: any) => {
        if (!value) return undefined;
        if (typeof value.get_email === "function") return value.get_email();
        if (typeof value.Email === "string") return value.Email;
        if (typeof value.email === "string") return value.email;
        return undefined;
    };

    const formatDateTime = (value: any) => {
        if (!value) return "";
        if (typeof value.format === "function") return value.format("HH:mm DD.MM.YYYY");
        return moment(value).format("HH:mm DD.MM.YYYY");
    };


    useEffect(() => {
        dispatch(
            getItems({
                listName: historyChangeFieldsDocumentListName,
                filters: {
                    DocumentID: versionView || documentCardID,
                    VersionDocument: (versionView && true) || undefined,
                },
                sortOrder: { name: "ID", asc: true },
            })
        );
    }, [dispatch, documentCardID, versionView]);

    useEffect(() => {
        if (historyCard.length > 0) {
            historyCard.forEach((history: any) => {
                let tempApprovers = `<div class="flex flex-col gap-2">`;
                if (history.Approvers && history.Approvers.length > 0) {
                    let userHistory: any;
                    if (history.ImportAuthor) {
                        userHistory = getUserEmail(history.ImportAuthor);
                    } else {
                        userHistory = getUserEmail(history.Author);
                    }
                    history.Approvers.forEach((approver: any) => {
                        const approverEmail = getUserEmail(approver) || approver?.Email;
                        tempApprovers += `<div class="flex items-center gap-2 relative">
                        ${(approverEmail && users[approverEmail] && users[approverEmail].avatar && `<img class="w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6" src="${users[approverEmail].avatar}" />`) || `<div class="flex items-center justify-center w-6 h-6 rounded-full max-sm:h-6 max-sm:w-6 bg-darkblue">
                                <span class="font-medium text-[12px] max-sm:text-[10px] text-white select-none">${(approverEmail && users[approverEmail] && users[approverEmail].displayName && users[approverEmail].displayName.split(' ')[0][0] + users[approverEmail].displayName.split(' ')[1][0]) || ""}</span>
                            </div>`}
                    <div class="flex flex-col justify-center items-start">
                        <span class="text-sm text-[#111928]">${(approverEmail && users[approverEmail] && users[approverEmail].displayName) || ""}</span>
                    </div>
                    ${(userHistory && approverEmail && userHistory.toLowerCase() !== approverEmail.toLowerCase() && `<div class="bg-white/[.75] absolute w-full h-full"></div>`) || ''}
                </div>`
                    });
                    tempApprovers += `</div>`;
                    setApprovers((prevState: any) => {
                        return {
                            ...prevState,
                            ...{ [history.ID]: tempApprovers }
                        }
                    });
                }
            });
        }
    }, [historyCard, users]);



    return (
        <div className="flex-1 bg-white rounded-lg shadow-xl">
            {statusGetHistory === "LOADING" && <Loading />}
            <div className="relative px-0">
                {historyCard.length > 1 &&
                    <div className="absolute left-[14.5px] h-full border border-solid border-[#DFE4EA] hidden sm:block"></div>
                }
                {statusGetHistory !== "LOADING" && historyCard.length === 0 && (
                    <div className="py-8 text-sm text-[#637381]">Нет данных</div>
                )}
                {historyCard.length > 0 && historyCard.map((history: any) => (
                    <div className="history_block flex flex-col w-full my-6 -ml-1.5">
                        <div className="pt-5 flex items-start z-10 mb-2">
                            <div
                                className="w-2.5 h-2.5 rounded-full mr-4 mt-1.5"
                                style={{ backgroundColor: getHistoryTimelineColorMobile(history.Statuses) }}
                            ></div>
                            <span className="text-[#637381] text-sm whitespace-nowrap">{formatDateTime(history.ChangeDate || history.Created)}</span>
                        </div>
                        <div className="flex p-5 flex-col justify-center items-start gap-5 flex-[1_0%_0%] w-9/12 rounded-lg border border-solid border-[#DFE4EA] w-full">
                            <div className="w-full ">
                                <div className="flex items-center gap-2">
                                    {history.ImportAuthor ? (
                                        <UserAvatar
                                            avatar={(getUserEmail(history.ImportAuthor) && users[getUserEmail(history.ImportAuthor)] && users[getUserEmail(history.ImportAuthor)].avatar) || null}
                                            shortName={(getUserEmail(history.ImportAuthor) && users[getUserEmail(history.ImportAuthor)] && users[getUserEmail(history.ImportAuthor)].displayName && users[getUserEmail(history.ImportAuthor)].displayName.split(' ')[0][0] + users[getUserEmail(history.ImportAuthor)].displayName.split(' ')[1][0]) || ""}
                                            displayName={(getUserEmail(history.ImportAuthor) && users[getUserEmail(history.ImportAuthor)] && users[getUserEmail(history.ImportAuthor)].displayName) || ""}
                                            email={getUserEmail(history.ImportAuthor) || ""}
                                        />
                                    ) : (
                                        <UserAvatar
                                            avatar={(getUserEmail(history.Author) && users[getUserEmail(history.Author)] && users[getUserEmail(history.Author)].avatar) || null}
                                            shortName={(getUserEmail(history.Author) && users[getUserEmail(history.Author)] && users[getUserEmail(history.Author)].displayName && users[getUserEmail(history.Author)].displayName.split(' ')[0][0] + users[getUserEmail(history.Author)].displayName.split(' ')[1][0]) || ""}
                                            displayName={(getUserEmail(history.Author) && users[getUserEmail(history.Author)] && users[getUserEmail(history.Author)].displayName) || ""}
                                            email={getUserEmail(history.Author) || ""}
                                        />
                                    )}
                                    {history.ImportAuthor ? (
                                        <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">{(getUserEmail(history.ImportAuthor) && users[getUserEmail(history.ImportAuthor)] && users[getUserEmail(history.ImportAuthor)].displayName) || ""}</span>
                                            <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: (getUserEmail(history.ImportAuthor) && users[getUserEmail(history.ImportAuthor)] && users[getUserEmail(history.ImportAuthor)]['jobTitle']) || "" }} />
                                        </div>
                                    ) : (
                                        <div className="flex flex-col justify-center items-start">
                                            <span className="text-sm text-[#111928]">{(getUserEmail(history.Author) && users[getUserEmail(history.Author)] && users[getUserEmail(history.Author)].displayName) || ""}</span>
                                            <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: (getUserEmail(history.Author) && users[getUserEmail(history.Author)] && users[getUserEmail(history.Author)]['jobTitle']) || "" }} />
                                        </div>
                                    )}
                                    {history.Approvers && history.Approvers.length > 1 &&
                                        <TooltipItem position="top-left" className="w-max" tooltipsComponent={approvers[history.ID]} tooltipsText="">
                                            <div className="flex items-center flex-col">
                                                <ArrowDown />
                                            </div>
                                        </TooltipItem>
                                    }
                                </div>
                                <HistoryStatuses statuses={history.Statuses} />
                            </div>
                            {history.Comment &&
                                <div className="flex items-center gap-2">
                                    <Comment />
                                    <span className="text-sm text-[#111928] mt-2">{history.Comment}</span>
                                </div>
                            }
                            <HistoryFieldChanges documentCardID={documentCardID} versionView={versionView} JsomHistoryFields={history.JSONChangesFields} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HistoryCard;
